import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'recordingElapsedLabel',
  standalone: true,
  pure: true,
})
export class RecordingElapsedLabelPipe implements PipeTransform {
  transform(seconds: number | null | undefined): string {
    if (seconds === null || seconds === undefined) {
      return '';
    }

    return this.formatRecordingElapsed(seconds);
  }

  private formatRecordingElapsed(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remaining_seconds = seconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(remaining_seconds).padStart(2, '0')}`;
  }
}
